(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["card-color-swatches"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('card-color-swatches')) {
    customElements.define(
      'card-color-swatches',
      class CardColorSwatches extends HTMLElement {
        connectedCallback() {
          this.card = this.closest('.card-wrapper');
          if (!this.card) return;
          this.images = this.card.querySelectorAll('.card__media .media > img');
          this.addEventListener('click', this.onClick);
          this.addEventListener('pointerenter', this.preloadImages, { once: true });
        }

        onClick = (event) => {
          const button = event.target.closest('button[data-variant-id]');
          if (!button) return;
          this.querySelectorAll('button[data-variant-id]').forEach((swatch) => {
            swatch.setAttribute('aria-pressed', swatch === button ? 'true' : 'false');
          });
          this.showColor(button);
          this.card.querySelectorAll('.card__heading a[href]').forEach((link) => {
            const url = new URL(link.href);
            url.searchParams.set('variant', button.dataset.variantId);
            link.href = url.pathname + url.search;
          });
        };

        preloadImages = () => {
          const sizes = this.images?.[0]?.sizes;
          this.querySelectorAll('button[data-image-srcset]').forEach(({ dataset }) => {
            const image = new Image();
            image.sizes = sizes;
            image.srcset = dataset.imageSrcset;
          });
        };

        showColor({ dataset }) {
          if (!this.images?.length || !dataset.imageSrc) return;
          const [primary, secondary] = this.images;
          primary.srcset = dataset.imageSrcset;
          primary.src = dataset.imageSrc;
          primary.alt = dataset.imageAlt;
          if (secondary) {
            secondary.srcset = dataset.secondarySrcset;
            secondary.src = dataset.secondarySrc;
            secondary.alt = dataset.secondaryAlt;
          }
        }
      }
    );
  }
  } catch(e) { console.error(e); }
})();

})();
